import Half_Doors from "../../../assets/images/Half_Doors.jpg";
import Full_Doors from "../../../assets/images/Full_Doors.png";
import Windscreen1 from "../../../assets/images/Frontglasswindscreen1.jpg";
import Windscreen2 from "../../../assets/images/Frontglasswindscreenopen.jpg";
import Petrol_Vehicle_Five from "../../../assets/images/1000EFIImg/1000EFIwithnewdoors3.jpg";
import Windscreen from "../../../assets/images/Windscreen.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRef, useState } from "react";
import Electrical_one from "../../../assets/images/1500EFIImg/1500Ewithnewdoors1.png";

const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-prev`}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        left: "-50px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        backgroundColor: "black",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <FaChevronLeft style={{ color: "white", fontSize: "20px" }} />
    </div>
  );
};

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-next`}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "-50px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        backgroundColor: "black",
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <FaChevronRight style={{ color: "white", fontSize: "20px" }} />
    </div>
  );
};

const NZAccessories = () => {
  const sliderRef = useRef(null);
  const windscreenRef = useRef(null);
  const doorsRef = useRef(null);

  const [openImage, setOpenImage] = useState(null);

  // Tooltip state
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);

  const settings = {
    // dots: false, // No pagination dots
    infinite: true,
    speed: 1200, // Slower transition animation (was 500)
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000, // Slower slide change (was 6000)
    arrows: false, // Enable left/right arrows only
    // prevArrow: <CustomPrevArrow />, // Custom arrow components
    // nextArrow: <CustomNextArrow />,
  };

  return (
    <>
      <div className="pt-[86px] pb-[65px] bg-white">
        <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
          <div className="custom-container px-[30px] text-center">
            <div>
              <div className="kuunari-bold lg:text-[78px] md:text-[60px] text-[40px] leading-[71px] text-center ">
                All accessories can be supplied at the time of vehicle purchase
                or supplied retrospectively.
              </div>
              <p className="text-center text-[#383838] text-[30px] leading-[68px] pt-[30px] pb-[13px] kuunari-bold uppercase">
                Fully Enclosed Cabin
              </p>
              <p className="text-gray-600 text-base leading-7 text-left">
                A fully enclosed all-weather passenger cabin can be created by
                adding a rear enclosure complete with window, Full glass
                windscreen (i.e. opening), and either full or half doors. All
                cabin accessories can be purchased individually and installed at
                any time.
              </p>
              <div className="pt-[5px] pb-[8px] text-center ">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-4">
                  <div className="col-span-1 text-center">
                    <p className="text-center text-[#383838] text-[54px] pt-[3px]  kuunari-bold">
                      Windscreen
                    </p>
                    {/* <div className="w-full  pb-[15px]"> */}
                    {/* <Slider {...settings}> */}
                    {/* <div>
                        <img src={Windscreen} alt="Windscreen" className="w-full rounded-lg object-cover" />
                        <p className="text-[18px] font-semibold text-[#383838] mt-2">&nbsp;</p>
                      </div> */}

                    {/* </Slider> */}
                    {/* </div> */}
                    <div className="relative w-full  pb-[10px]">
                      {/* Custom Previous Arrow */}
                      <div
                        className="absolute left-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
                        onClick={() => windscreenRef.current?.slickPrev()}
                      >
                        <FaChevronLeft className="text-white text-sm" />
                      </div>

                      {/* Slick Slider */}
                      <Slider ref={windscreenRef} {...settings}>
                        {/* Image 1 */}
                        <div>
                          <img
                            onMouseMove={(e) => {
                              setTooltipPos({ x: e.clientX, y: e.clientY });
                              setShowTooltip(true);
                            }}
                            onMouseLeave={() => setShowTooltip(false)}
                            onClick={() => setOpenImage(Electrical_one)}
                            src={Electrical_one}
                            alt="Windscreen1"
                            className="relative group cursor-pointer border border-black w-full rounded-lg object-cover h-[91%]"
                          />
                        </div>
                        <div>
                          <img
                            onMouseMove={(e) => {
                              setTooltipPos({ x: e.clientX, y: e.clientY });
                              setShowTooltip(true);
                            }}
                            onMouseLeave={() => setShowTooltip(false)}
                            onClick={() => setOpenImage(Windscreen2)}
                            src={Windscreen2}
                            alt="Windscreen2"
                            className=" relative group cursor-pointer w-full rounded-lg object-cover h-[91%]"
                          />
                        </div>
                      </Slider>

                      {/* Custom Next Arrow */}
                      <div
                        className="absolute right-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
                        onClick={() => windscreenRef.current?.slickNext()}
                      >
                        <FaChevronRight className="text-white text-sm" />
                      </div>
                    </div>
                    <ul className="text-left text-gray-600 text-[16px] space-y-1">
                      <li className="flex items-start gap-2">
                        <span>➢</span> Glass opening windscreen with wiper and
                        washer.
                      </li>
                      <li className="flex items-start gap-2">
                        <span>➢</span> Easy opening assisted by air struts.
                      </li>
                      <li className="flex items-start gap-2">
                        <span>➢</span> The windscreen can also be held partly
                        open to provide an airflow.
                      </li>
                      <li className="flex items-start gap-2">
                        <span>➢</span> The vehicle must NOT be driven with the
                        windscreen fully extended.
                      </li>
                    </ul>
                  </div>
                  <div className="col-span-1 text-center justify-center">
                    <p className="text-[#383838] text-[54px] pt-[3px]  kuunari-bold">
                      Doors
                    </p>
                    {/* <div className=" w-full  pb-[15px] relative">
                      <Slider {...settings} className="w-full " ref={(slider) => (this.slider = slider)} {...settings}>
                        <div>
                          <img src={Half_Doors} alt="Half Doors" className="w-full rounded-lg  object-cover" />
                          <p className="text-[18px] font-semibold text-[#383838] mt-1">Half Doors</p>
                        </div>
                        <div>
                          <img src={Full_Doors} alt="Full Doors" className="w-full rounded-lg  object-cover" />
                          <p className="text-[18px] font-semibold text-[#383838] mt-2">Full Doors</p>
                        </div>
                      </Slider>
                      <CustomPrevArrow onClick={() => this.slider.slickPrev()} />
                      <CustomNextArrow onClick={() => this.slider.slickNext()} />
                    </div> */}
                    <div className="relative w-full  pb-[10px]">
                      {/* Custom Previous Arrow */}
                      <div
                        className="absolute left-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
                        onClick={() => doorsRef.current?.slickPrev()}
                      >
                        <FaChevronLeft className="text-white text-sm" />
                      </div>

                      {/* Slick Slider */}
                      <Slider ref={doorsRef} {...settings}>
                        <div>
                          <img
                            onMouseMove={(e) => {
                              setTooltipPos({ x: e.clientX, y: e.clientY });
                              setShowTooltip(true);
                            }}
                            onMouseLeave={() => setShowTooltip(false)}
                            onClick={() => setOpenImage(Half_Doors)}
                            src={Half_Doors}
                            alt="Half Doors"
                            className="relative group cursor-pointer w-full rounded-lg object-cover"
                          />
                          <p className="text-[18px] font-semibold text-[#383838] mt-1">
                            Half Doors
                          </p>
                        </div>
                        <div>
                          <img
                            onMouseMove={(e) => {
                              setTooltipPos({ x: e.clientX, y: e.clientY });
                              setShowTooltip(true);
                            }}
                            onMouseLeave={() => setShowTooltip(false)}
                            onClick={() => setOpenImage(Petrol_Vehicle_Five)}
                            src={Petrol_Vehicle_Five}
                            alt="Full Doors"
                            className="relative group cursor-pointer border border-black w-full rounded-lg object-cover"
                          />
                          <p className="text-[18px] font-semibold text-[#383838] mt-2">
                            Full Doors
                          </p>
                        </div>
                      </Slider>

                      {/* Custom Next Arrow */}
                      <div
                        className="absolute right-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
                        onClick={() => doorsRef.current?.slickNext()}
                      >
                        <FaChevronRight className="text-white text-sm" />
                      </div>
                    </div>
                    <ul className="text-left text-gray-600 text-[16px] space-y-1">
                      <li className="flex items-start gap-2">
                        <span>➢</span> Steel frame with hardened polycarbonate
                        skins for excellent strength & visibility.
                      </li>
                      <li className="flex items-start gap-2">
                        <span>➢</span> Sliding window for airflow and access
                        without opening the door.
                      </li>
                      <li className="flex items-start gap-2">
                        <span>➢</span> Easy installation or removal for seasonal
                        use.
                      </li>
                      <li className="flex items-start gap-2">
                        <span>➢</span> Fully lockable.
                      </li>
                      <li className="flex items-start gap-2">
                        <span>➢</span> Full and half door options.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 max-w-[1400px] mx-auto pt-[10px]">
              <img src={Accessory_Seventh} alt="1" className="w-full h-[260px] object-cover" />
              <img src={Accessory_Six} alt="" className="w-full h-[260px] object-cover" />
              <img src={Accessory_Five} alt="" className="w-full h-[260px] object-cover" />
            </div> */}
          </div>
        </div>
      </div>

      {/* TOOLTIP FOLLOW MOUSE */}
      {showTooltip && (
        <div
          className="
            fixed z-[9999] bg-black text-white text-[13px]
            px-3 py-1 rounded-md shadow-lg
            pointer-events-none
            transition-opacity duration-100
          "
          style={{
            top: tooltipPos.y + 15 + "px",
            left: tooltipPos.x + 15 + "px",
          }}
        >
          Click here to expand
        </div>
      )}

      {/* FULLSCREEN MODAL */}
      {openImage && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
          onClick={() => setOpenImage(null)}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpenImage(null);
            }}
            className="
        fixed top-4 right-4
        text-white text-4xl font-bold
        bg-black/70 hover:bg-black
        p-2 rounded-full
        z-[10000]
      "
          >
            ✕
          </button>

          {/* IMAGE */}
          <img
            src={openImage}
            alt="Expanded View"
            className="max-w-[95%] max-h-[95%] rounded-lg object-contain shadow-xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};
export default NZAccessories;
